// extracted by mini-css-extract-plugin
export default {"container":"static-React-Components-_Containers-SingleColumn-___index-module__container"};